import { useCallback } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, Redirect, useLocation } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { loginAction } from '../loginActions.js';
import {
    makeSelectAppFormError,
    makeSelectAppLoggedIn,
    makeSelectAppLoggedInProcess,
} from '../../../app/appSelectors.js';
import { LoginBoxStyled, LoginForgotPasswordLinkContainerStyled, LoginStyled } from './styled/LoginStyled.js';
import LoginWrapper from './LoginWrapper.jsx';
import FormPasswordEye from '../../../components/FormPasswordEye/FormPasswordEye.jsx';
import { Loader } from '../../../components/Loader/Loader';
import { RouterPaths } from '../../../app/appConstants';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext.js';
import { useInitialUrlSearchParams } from '../../../hooks/useInitialUrlSearchParams';
import { useFormFieldErrors } from '../../../hooks/useFormFieldErrors';
import { LOGIN_FIELDS_ERRORS } from './loginConstants';
import { resetFormErrorAction } from '../../../app/appActions';

function Login(props) {
    const { getLangPath } = useLangContext();
    const location = useLocation();
    const {
        formError,
        loggedIn,
        loggedInProcess,
        loginAction,
        resetFormError,
    } = props;

    const { email: initialEmail } = useInitialUrlSearchParams(['email']);
    const { email: emailError, password: passwordError, common: commonError } =
        useFormFieldErrors(LOGIN_FIELDS_ERRORS, formError);

    const loginSubmitHandler = useCallback((e) => {
        e.preventDefault();
        loginAction({
            email: e.target.querySelector('[name=email]').value,
            password: e.target.querySelector('[name=password]').value,
        });
    }, [loginAction]);

    // const handleRegistrationClick = useCallback(() => {
    //     const email = document.querySelector('[name=email]').value;
    //     appHistory.push(`${RouterPaths.registration}?email=${email}`);
    // }, []);

    const handleChange = useCallback((isValid) => {
        if (!isValid) {
            resetFormError();
        }
    }, [resetFormError]);

    if (loggedIn) {
        return <Redirect to={{
            pathname: location.state?.originPathname || RouterPaths.trade,
            search: location.state?.originSearch,
            state: location.state,
        }} />;
    }

    return <LoginWrapper hideAuthButton>
        <LoginStyled>
            <LoginBoxStyled>
                <Form.Group className="mb-5">
                    <h1 className="text-center">{getLangPath('promo.fx.log_in')}</h1>
                </Form.Group>
                <Form onSubmit={loginSubmitHandler}>
                    <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Control
                            defaultValue={initialEmail || ''}
                            isInvalid={!!emailError}
                            name="email"
                            onChange={() => handleChange(!emailError)}
                            placeholder={getLangPath('promo.fx.errors.email1')}
                            required
                            type="email"
                        />
                        {
                            emailError && <>
                                <Form.Control.Feedback type="invalid">
                                    {getLangPath(emailError)}
                                    {/*{emailError === 'error.email_didnt_registered' && (*/}
                                    {/*    <>.&nbsp;<u onClick={handleRegistrationClick}>{getLangPath('sign_up.title')}</u></>*/}
                                    {/*)}*/}
                                </Form.Control.Feedback>
                            </>
                        }
                    </Form.Group>

                    <Form.Group className="mb-2" controlId="formBasicPassword">
                        <FormPasswordEye
                            isInvalid={!!passwordError}
                            name="password"
                            onChange={() => handleChange(!passwordError)}
                            placeholder={getLangPath('promo.fx.errors.password1')}
                            required
                        />
                        {
                            passwordError && <>
                                <Form.Control.Feedback type="invalid">
                                    {getLangPath(passwordError)}
                                    {/*{passwordError === 'error.email_didnt_registered' && (*/}
                                    {/*    <>.&nbsp;<u onClick={handleRegistrationClick}>{getLangPath('sign_up.title')}</u></>*/}
                                    {/*)}*/}
                                </Form.Control.Feedback>
                            </>
                        }
                    </Form.Group>
                    {
                        !!commonError && (
                            <Form.Control.Feedback type="invalid" className="d-block mt-3">
                                {getLangPath(commonError)}
                            </Form.Control.Feedback>
                        )
                    }
                    <LoginForgotPasswordLinkContainerStyled>
                        <Link to={RouterPaths.forgot}>
                            {getLangPath('promo.fx.sign_in.password')}
                        </Link>
                    </LoginForgotPasswordLinkContainerStyled>
                    <div className="d-grid">
                        <Button variant={'primary'} size={'lg'} type="submit" className="mb-4">
                            {getLangPath('promo.fx.log_in')}
                        </Button>
                        {/*<Button variant={'outline-info'} size={'md'} onClick={handleRegistrationClick} type="button">*/}
                        {/*    {getLangPath('log_in.not_a_member')}*/}
                        {/*</Button>*/}
                    </div>
                </Form>
                <Loader show={loggedInProcess} />
            </LoginBoxStyled>
        </LoginStyled>
    </LoginWrapper>;
}

const mapStateToProps = createStructuredSelector({
    loggedIn: makeSelectAppLoggedIn(),
    loggedInProcess: makeSelectAppLoggedInProcess(),
    formError: makeSelectAppFormError(),
});

const mapDispatchToProps = (dispatch) => ({
    loginAction: (payload) => dispatch(loginAction(payload)),
    resetFormError: (payload) => dispatch(resetFormErrorAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
